// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2bnZT","right":"styles_right__8dpDv"};